import { getAppConfig } from '../..';
export function getB2CPolicyInfo() {
    // can't use useConfig hook here because we aren't in a component
    const configuration = getAppConfig();
    return {
        authorities: {
            signUpSignIn: configuration.REACT_APP_MSAL_POLICY_AUTHORITY_ROOT + configuration.REACT_APP_MSAL_SIGNUPSIGNIN_POLICY,
            forgotPassword: configuration.REACT_APP_MSAL_POLICY_AUTHORITY_ROOT + configuration.REACT_APP_MSAL_FORGOTPASSWORD_POLICY,
            editProfile: configuration.REACT_APP_MSAL_POLICY_AUTHORITY_ROOT + configuration.REACT_APP_MSAL_EDITPROFILE_POLICY,
        },
        authorityDomain: configuration.REACT_APP_MSAL_B2C_AUTHORITYDOMAIN,
    };
}
